import BR from "../assets/flags/brazil.png"
import JA from "../assets/flags/japan.png"
import USA from "../assets/flags/united_states.png"

export const FLAG_LIST = [
  { img: JA, config: "ja" },
  { img: USA, config: "en_us" },
  { img: BR, config: "pt_br" },
] as const
